@use '~@frontrow/console/css/variables.scss';

.matchCheckBoxGroup label {
  font-size: variables.$font-size-sm;
  padding-right: variables.$std-padding-lg;
  margin-bottom: variables.$std-margin-lg;
}

.matchCheckBoxGroup input {
  transition: scale(2);
  border: solid 1px variables.$gray-light-1;
}

.allMatchedStudent {
  font-weight: bold;
  color: #0fad00;
}

.nameTeacherMatchedStudent {
  font-weight: bold;
  color: #428bca;
}
